module.exports = __webpack_public_path__ + "img/info.dcc81449.webp";